module.exports = __webpack_public_path__ + "static/media/pole2.fd2c67c4.png";